import $ from 'jquery';
import { View } from 'backbone';
import listService from 'ListService';
import util from 'util/Util';
import widgetUtil from 'util/WidgetUtil';
import Template from 'report/properties/main/field.ejs';

class MainFieldView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change #field' :'updateField'
        };

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateField(ev){
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;

        // PF-3553 IE doesnt have the selectedOptions property so im feeding the value with selected index instead.
        let dataType =  '';
        if (propVal !== 'none') {
            dataType =  ev.currentTarget.selectedOptions ?
                            ev.currentTarget.selectedOptions[0].attributes.dataType.value :
                            ev.currentTarget.options[ev.currentTarget.selectedIndex].attributes.dataType.value;
        }
        const colid = "0";

        if (this.model.get('Columns')) {
            this.updateColumnProperty(colid, 'fieldId', propVal);
            this.updateColumnProperty(colid, 'fieldDataType', dataType);
            this.updateReportingMetaDataColumnField(colid, listService.getCleanedId(propVal), dataType);
        } else {
            this.model.set( 'fieldId', propVal, {silent: true});
            if (!this.model.get('operator')) {
                // Add default operator
                this.model.set('operator', 'equal', {silent: true})
            }
        }

        this.model.set( propName, propVal, {silent: true} );
        this.model.set('widgetText', widgetUtil.getWidgetText(this.model), {silent: true});
        this.model.trigger('widgetTextUpdated');
    }

    setFieldsFromColumn() {
        const columns = this.model.get('Columns');
        if(columns) {
            const fieldValue = columns.Column[0].Properties.fieldId;
            this.model.set('field', fieldValue, {silent: true});
        }
    }

    updateColumnProperty(rowid, propName, propVal) {
        const columns = this.model.get('Columns');

        columns.Column[rowid].Properties[propName] = propVal;
    }

    // Look up Column by ID and set properties
    updateReportingMetaDataColumnField(rowid, dsFieldId, dataType ) {
        const md = listService.getReportingMetaData(this.model.get('id'));

        if (md && md.Columns) {
            _.forEach(md.Columns, (col) => {
                if (col.id.toString() === rowid.toString()) {
                    col.Expression.Argument = {type: 'reporting_datasourceField', value: dsFieldId, dataType: dataType};
                }
            });
        }

    }

    // Only want to list Fields marked as InUse (Configured in the DataSource)
    loadFieldsFromDatasource( dsId ) {
        const ds = listService.getDataSources(dsId);

        if (ds && ds.Fields && ds.Fields.Field) {
            const fieldEl = $('#field');
            _.forEach(ds.Fields.Field, (field) => {
                if (util.isTrue(field.inUse)) {
                    let fname = '';

                    switch (field.id) {
                        case 'CreateDate':
                            fname = 'Meta - Last Submission Date';
                            break;
                        case 'E':
                            fname = 'Meta - Instance Number';
                            break;
                        case 'FormInstanceGUID':
                            fname = 'Meta - Instance ID';
                            break;
                        case 'FormInstanceId':
                            fname = 'Meta - Link';
                            break;
                        case 'MajorVersion':
                            fname = 'Meta - Version Major';
                            break;
                        case 'MinorVersion':
                            fname = 'Meta - Version Minor';
                            break;
                        case 'Name':
                            fname = 'Meta - Instance Name';
                            break;
                        case 'ParentGUID':
                            fname = 'Meta - Parent Instance ID';
                            break;
                        case 'StageName':
                            fname = 'Meta - Stage';
                            break;
                        default:
                            fname = field.name.replace('|',' - ');
                            break;
                    }

                    const elOpt = new Option((field.displayName.trim() || fname), field.id);
                    fieldEl[0].options[fieldEl[0].options.length] = elOpt;
                    elOpt.setAttribute("dataType", field.dataType);
                }
            });

            fieldEl[0].value = this.model.get('fieldId');

            $('#fieldEl').append('<optgroup label="──────────"></optgroup>');
            $('#fieldEl').append('<option value="Formula">Formula</option>');
        }
    }

    render() {

        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.loadFieldsFromDatasource( listService.cleanId( this.model.get('dataSourceId') ));

        this.setFieldsFromColumn();

        $("#field option[value='" + this.model.get('field') + "']").prop('selected', true);

        this.delegateEvents();
        return this;
    }

}

export default MainFieldView;
